import { SecretReference } from 'libs/end-to-end/src/types/secrets/secret-reference';
import { BaseIntegration } from 'libs/end-to-end/src/types/databases/integrations/base-integration';
import { z } from 'zod';

export const PeregrineIntegration = BaseIntegration.extend({
  integrationType: z.literal('Peregrine'),
  usernameSecretReference: SecretReference.optional(),
  passwordSecretReference: SecretReference.optional(),
});

export type PeregrineIntegration = z.infer<typeof PeregrineIntegration>;
